import BaseCollectiveLogListItem from './BaseCollectiveLogListItem'
import { ICollectiveLogListItemProps } from './common'

const CollectiveLogDataOnProposalRequireVoteSignatureChanged: React.FC<
  ICollectiveLogListItemProps<'CollectiveLogDataOnEnableWithdrawsChanged'>
> = ({ bundledCollectiveLog, isLast }) => (
  <BaseCollectiveLogListItem
    bundle={bundledCollectiveLog}
    isLast={isLast}
    summaryActionText={`Setting "Enable Withdrawals?" was changed ${
      bundledCollectiveLog.logs.length === 1
        ? bundledCollectiveLog.logs[0].data.enableWithdraws
          ? `to 'Yes'`
          : `to 'No'`
        : ''
    }`}
    hideSummaryActors
    detailsActionText={log => (
      <>
        {`Enable Withdrawals was changed to `}
        {log.data.enableWithdraws ? `'Yes'` : `'No'`}
      </>
    )}
  />
)

export default CollectiveLogDataOnProposalRequireVoteSignatureChanged
